exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".subTitle___BUMXn {\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-size: 20px;\n  font-weight: 500;\n}\n.detailsHeader___3Iu9Z {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.detailsHeader___3Iu9Z h2 {\n  margin: 0;\n}\n.passwordNote___rx07j {\n  color: #505050;\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: 12px;\n}\n.meetingDetail___6igEt {\n  color: #505050;\n  line-height: 1;\n  padding-bottom: 8px;\n}\n.meetingDetail___6igEt b {\n  color: #21201f;\n}\n.eventDetails___pwJRq {\n  margin-bottom: 60px;\n  margin-top: 40px;\n}\n.eventDetails___pwJRq b {\n  font-weight: 500;\n}\n", ""]);

// exports
exports.locals = {
	"subTitle": "subTitle___BUMXn",
	"detailsHeader": "detailsHeader___3Iu9Z",
	"passwordNote": "passwordNote___rx07j",
	"meetingDetail": "meetingDetail___6igEt",
	"eventDetails": "eventDetails___pwJRq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/VirtualEvents/ZoomEventDetailsModule/ZoomEventDetailsModule.module.less
// module id = 2350
// module chunks = 51